import { render, staticRenderFns } from "./BaseAudio.vue?vue&type=template&id=c7f8db74&scoped=true&"
import script from "./BaseAudio.vue?vue&type=script&lang=js&"
export * from "./BaseAudio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7f8db74",
  null
  
)

export default component.exports